<div class="form form--entry-field" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label [noIndent]="true"></basic-label>
  </div>
  <div class="form__field" [ngClass]="customWidth">
    <basic-text-input
      #textInputComponent
      [propertyName]="questionItem.prop"
      [placeholder]="questionItem.placeholder"
      [requiredBasedOn]="questionItem.requiredBasedOn"
      [disableConditionally]="disableConditionally"
    ></basic-text-input>
  </div>
</div>
